import { useFormContext } from 'react-hook-form';

import type { GiftCardFormFields } from '@/modules/cart/domain/Cart';
import giftCardLogo from '@/modules/perseo-billing/assets/images/gift-card-logo.png';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

import './style.scss';

export const NotSubmittedGiftCardPreview = () => {
  const GiftCardFormFields = useFormContext<GiftCardFormFields>();
  const { formState, watch } = GiftCardFormFields;
  const { isValid } = formState;

  const cardNumber = watch('cardNumber');
  const cardPassword = watch('cardNumber');
  const passwordMasked = cardPassword.replace(/./g, '*');

  return (
    <div
      className="co-w-1/2 co-hidden lg:co-flex co-bg-back-gray co-rounded-lg co-p-16px co-pb-8px co-items-center co-justify-center"
      style={{ maxHeight: 242 }}
    >
      <div className="co-w-[250px] co-h-[156px] co-rounded-8px co-text-pds-neutral-900 co-overflow-hidden">
        <div
          className={`co-w-full co-h-full co-relative co-flex co-flex-col co-justify-center co-gap-16px co-p-16px card front ${
            isValid ? 'valid' : ''
          }`}
        >
          <div className={`background ${isValid ? 'valid' : ''}`}></div>
          <img
            src={giftCardLogo}
            alt={'product'}
            width={48}
            height={48}
            className="co-absolute co-top-0 co-left-16px"
          />

          <div className="co-flex co-justify-end">
            <Typography align="right">
              {cardNumber
                ? maskCardNumber(String(cardNumber))
                : '**** **** **** **** ****'}
            </Typography>
          </div>

          <div className="co-flex co-justify-end">
            <Typography align="right">
              {passwordMasked ? passwordMasked : '****'}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

const maskCardNumber = (cardNumber: string): string => {
  const trimedNumber = cardNumber.replace(/ /g, '');
  const groupCount = trimedNumber.length > 16 ? 5 : 4;
  const groups = new Array(groupCount).fill('****');
  const filledGroupCount = Math.ceil(trimedNumber.length / 4);

  for (let i = 0; i < filledGroupCount; i++) {
    groups[i] = trimedNumber.slice(i * 4, i * 4 + 4).padEnd(4, '*');
  }

  return groups.join(' ');
};
